import styles from './Pedidos.module.scss';
import NavBar from "../../components/NavBar";
import FormularioPedido from '../../components/Form/FormPedido';
import { useState } from 'react';
import { IPedido } from '../../interfaces/pedido.interface';
import MenuPedidos from '../../components/MenuPedidos';
import FormItemPedido from '../../components/Form/FormItemPedido';
import { IitemPedido } from '../../interfaces/itemPedido';
import useCreatePedido from '../../hooks/pedidos/useCreatePedido';
import CardItemPedido from '../../components/Cards/CardItemPedido';
import Botao from '../../components/Botao';
import useCreateItemPedido from '../../hooks/itemPedido/useCreateItemPedido';
import SectionPedidosCadastrados from '../../components/Section/SectionPedidosCadastrados';
import useFetchPedidos from '../../hooks/pedidos/useFetchPedidos';

export default function Pedidos() {
    const [click, setClick] = useState<'formulario' | 'pedidos' | 'item' | 'menu' | 'loading'>('menu');
    const [itens, setItens] = useState<IitemPedido[]>([]);
    const [pedidoId, setPedidoId] = useState<string | null>(null); // Definir o estado do pedidoId
    const { createPedido } = useCreatePedido();
    const { createItemPedido, loading, error } = useCreateItemPedido();
    const { pedidos } = useFetchPedidos();

    const handlePedido = async (pedido: IPedido) => {
        try {
            setClick('loading');
            const id = await createPedido(pedido); // Captura o ID do pedido criado
            if (id) {
                setPedidoId(id); // Atualiza o estado do pedidoId
                setClick('item');
            } else {
                setClick('menu');
            }
        } catch (error) {
            console.error("Erro ao criar pedido:", error);
            setClick('menu');
        }
    };

    const handleItem = (item: IitemPedido) => {
        if (pedidoId) {
            const itemComPedidoId = { ...item, pedidoId };
            setItens((prevItens) => [...prevItens, itemComPedidoId]);
        } else {
            console.error("Falha ao adicionar item: pedidoId indefinido.");
        }
    };

    const salvarItens = async () => {
        try {
            setClick('loading');
            for (const item of itens) {
                console.log(item);
                await createItemPedido(item);
            }
        } catch (error) {
            console.log("Erro ao salvar itens:", error);
        } finally {
            setClick('menu');
            setItens([]); // Limpar itens após salvar
        }
    };

    if (error) {
        return <p>Erro: {error}</p>;
    }

    return (
        <main>
            <NavBar />

            {click === 'loading' && <h1>Carregando...</h1>}

            <div className={styles.container}>
                {(click === 'menu' || click === 'formulario' || click === 'pedidos') && (
                    <MenuPedidos
                        cadastrarPedido={() => setClick('formulario')}
                        verPedidos={() => setClick('pedidos')}
                    />
                )}

                <section className={styles.sectionConteudo}>
                    {click === 'formulario' && <FormularioPedido onSubmit={handlePedido} />}

                    {click === 'item' && pedidoId && (
                        <div style={{ display: 'flex', gap: 55 }}>
                            <FormItemPedido
                                pedidoId={pedidoId}
                                onSubmit={handleItem}
                            />

                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Botao text={'Finalizar'} onClick={salvarItens} />
                                <CardItemPedido itens={itens} />
                            </div>
                        </div>
                    )}

                    {click === 'pedidos' && <SectionPedidosCadastrados pedidos={pedidos} />}
                </section>
            </div>
        </main>
    );
}
